import React, { useState, useEffect } from 'react';
import "./App.css"; 
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';

import Navbar from './components/Navbar'; 
import Footer from './components/Footer';

// Pages
import NewsPage from './pages/NewsPage';
import HomePage from './pages/HomePage';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import StatsPage from './pages/StatsPage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ImageEditorPage from './pages/ProfessionalPixelStudio'; 
import DiscTestPage from './pages/DiscTestPage';

// NOVAS PÁGINAS PARA ADSENSE
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

// Contexts
import { AuthProvider } from './context/AuthContext';
import { AccessibilityProvider } from './context/AccessibilityContext';
import AccessibilityPanel from './components/ui/AccessibilityPanel';

// Componente auxiliar para disparar o AdSense em cada mudança de página
function AdSenseTrack() {
  const location = useLocation();

  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      // Silencia erros se o script ainda não carregou
    }
  }, [location]);

  return null;
}

function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    // Garante que o modo escuro é aplicado ao HTML
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <BrowserRouter>
      <AdSenseTrack /> {/* ✅ Ativa o rastreio de anúncios em SPAs */}
      <AuthProvider>
        <AccessibilityProvider>
          <Routes>
            {/* 1. Rotas Administrativas (Sem Navbar/Footer padrão) */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/editor" element={<ImageEditorPage />} />

            {/* 2. Rotas Públicas (Com Layout Padrão) */}
            <Route path="*" element={
              <div className="min-h-screen flex flex-col bg-white dark:bg-[#020617] transition-colors duration-300">
                <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
                
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/vagas" element={<JobsPage />} />
                    
                    {/* Detalhe da Vaga - idOrSlug aceita tanto o UUID quanto o nome-da-vaga */}
                    <Route path="/vagas/:idOrSlug" element={<JobDetailPage />} />
                    
                    <Route path="/noticias" element={<NewsPage />} /> 
                    <Route path="/noticias/:id" element={<NewsPage />} /> 
                    
                    <Route path="/estatisticas" element={<StatsPage />} />
                    <Route path="/contato" element={<ContactPage />} />
                    <Route path="/disc" element={<DiscTestPage />} />

                    {/* ✅ NOVAS ROTAS ADICIONADAS PARA O ADSENSE */}
                    <Route path="/privacidade" element={<PrivacyPolicy />} />
                    <Route path="/termos" element={<TermsOfUse />} />
                    
                    <Route path="*" element={
                      <div className="flex flex-col items-center justify-center p-20 text-center">
                        <h2 className="text-4xl font-black text-slate-800 dark:text-white">404</h2>
                        <p className="font-bold text-slate-500">Página não encontrada</p>
                      </div>
                    } />
                  </Routes>
                </main>

                <Footer />
                <AccessibilityPanel darkMode={darkMode} setDarkMode={setDarkMode} />
              </div>
            } />
          </Routes>
          
          <Toaster position="top-right" richColors closeButton />
        </AccessibilityProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;